import { withDefaults } from '@warp-drive/legacy/model/migration-support';

const ScholarshipSchema = withDefaults({
  type: 'scholarship',
  fields: [
    {
      kind: 'attribute',
      name: 'amount',
    },
    {
      kind: 'attribute',
      name: 'fromDate',
    },
    {
      kind: 'attribute',
      name: 'isActive',
    },
    {
      kind: 'attribute',
      name: 'isDependent',
    },
    {
      kind: 'attribute',
      name: 'scholarshipAward',
    },
    {
      kind: 'attribute',
      name: 'scholarshipStatusType',
    },
    {
      kind: 'attribute',
      name: 'thruDate',
    },
  ],
});

export default ScholarshipSchema;
